export type IGetDaysInMonth = (year: number, month: number) => number;

export function getDaysInMonth(year: number, month: number): number {
  const date = window.DexeroCoreApp._daylightSavingAdjust(new Date(year, month, 32));
  if (date) {
    return 32 - date.getDate();
  }

  return 0;
}
